import { createMMKV } from 'react-native-mmkv';
import * as Crypto from 'expo-crypto';

export const storage = createMMKV();

const KEYS = {
  TV_UUID: 'tv_uuid',
  ACCESS_TOKEN: 'access_token',
} as const;

/**
 * Get or create a persistent TV device UUID.
 * Generated once via expo-crypto and stored in MMKV.
 */
export function getTvUuid(): string {
  const existing = storage.getString(KEYS.TV_UUID);
  if (existing) return existing;

  const uuid = Crypto.randomUUID();
  storage.set(KEYS.TV_UUID, uuid);
  return uuid;
}

/**
 * Get the stored access token (JWT from the pairing flow).
 */
export function getAccessToken(): string | undefined {
  return storage.getString(KEYS.ACCESS_TOKEN);
}

/**
 * Save the access token received after successful TV pairing.
 */
export function setAccessToken(token: string): void {
  storage.set(KEYS.ACCESS_TOKEN, token);
}

/**
 * Clear the stored access token (logout).
 */
export function clearAccessToken(): void {
  storage.remove(KEYS.ACCESS_TOKEN);
}

/**
 * Check if the TV has been authenticated.
 */
export function isAuthenticated(): boolean {
  return !!storage.getString(KEYS.ACCESS_TOKEN);
}
